import { CommonModule, Location } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { ToastrService } from 'ngx-toastr';

import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { InputTextModule } from 'primeng/inputtext';

import { ConfirmationService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { ContextRoleService, GlobalsService, MetaService, SaveUserContextRoleProfileRequestDTO, confirmAction, isAssigned, isEmpty } from '../../data';
import { UserContextRoleScopeProfileBase } from './user-context-role-scope-profile-base';
import { UIBlockerComponent } from '../../data/components/ui-blocker/ui-blocker.componet';
import { DataFieldComponent } from '../../data/components/data-field/data-field.component';
import { UserContextRoleScopeProfileHeaderComponent } from './user-context-role-scope-profile-header.component';
import { SaveCancelButtonsComponent } from '../../shared/save-cancel-buttons/save-cancel-buttons.component';

@Component({
    selector: 'app-user-context-role-scope-profile-denied',
    templateUrl: './user-context-role-scope-profile-denied.component.html',
    styleUrls: ['./user-context-role-scope-profile-denied.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        TranslateModule,
        ConfirmDialogModule,
        InputTextModule,
        UIBlockerComponent,
        DataFieldComponent,
        UserContextRoleScopeProfileHeaderComponent,
        SaveCancelButtonsComponent,
    ],
    providers: [ConfirmationService, DynamicDialogRef],
})
export class UserContextRoleScopeProfileDeniedComponent extends UserContextRoleScopeProfileBase {
    private _denyDirectly: boolean;
    private _disableAutoUpdateSource?: string;
    private _deniedReason?: string;

    constructor(
        confirmSrv: ConfirmationService,
        dialogSrv: DialogService,
        contextRoleSrv: ContextRoleService,
        dialogRef: DynamicDialogRef,
        dialogCfg: DynamicDialogConfig,
        translateSrv: TranslateService,
        toastr: ToastrService,
        globals: GlobalsService,
        metaSrv: MetaService,
        location: Location,
    ) {
        super(confirmSrv, dialogSrv, contextRoleSrv, dialogRef, dialogCfg, translateSrv, toastr, globals, metaSrv, location);

        this._translateKey = `${this._translateKey}.denied`;

        this._denyDirectly = this.dialogCfg.data?.denyDirectly === true;
        this._disableAutoUpdateSource = this.dialogCfg.data?.disableAutoUpdateSource;
    }

    get isDenyValidated(): boolean {
        return !this.isLoading && this._deniedReason !== this.profile.deniedReason && !isEmpty(this.profile?.deniedReason);
    }

    override readProfilePermissions(): void {
        if (this._denyDirectly) {
            this.profile = { canEdit: true };
        } else {
            super.readProfilePermissions();
        }
    }

    override onReadProfilePermissions(): void {
        super.onReadProfilePermissions();

        this._deniedReason = this.profile?.deniedReason;
    }

    onSave() {
        const request: SaveUserContextRoleProfileRequestDTO = {
            profileStatus: 'denied',
            deniedReason: this.profile.deniedReason,
            disableAutomaticUpdate: true,
        };

        if (!isEmpty(this._disableAutoUpdateSource)) {
            confirmAction(this.confirmSrv, {
                header: this.translateDirect('account-information-scopes.confirm.denyProfile.header'),
                message: this.translateDirect('profile.disableAutoUpdate.confirm', { source: this._disableAutoUpdateSource }),
                acceptLabel: this.translateDirect('confirm'),
                cancelLabel: this.translateDirect('cancel'),
                onAccept: () => this.saveProfilePermissions(request),
                onCancel: () => this.onCancel(),
            });
        } else {
            this.saveProfilePermissions(request);
        }
    }
}
